export enum EDITOR_HOOK {
	BEFORE_KEY_DOWN,
	ON_KEY_DOWN,
	AFTER_KEY_DOWN,

	BEFORE_KEY_UP,
	ON_KEY_UP,
	AFTER_KEY_UP,

	BEFORE_PASTE,
	ON_PASTE,
	AFTER_PASTE,

	BEFORE_CUT,
	ON_CUT,
	AFTER_CUT,

	BEFORE_COPY,
	ON_COPY,
	AFTER_COPY,

	BEFORE_SELECTION_CHANGE,
	ON_SELECTION_CHANGE,
	AFTER_SELECTION_CHANGE,

	BEFORE_MUTATION_CHANGE,
	ON_MUTATION_CHANGE,
	AFTER_MUTATION_CHANGE,
}
